import myAxios from './myAxios';

export async function getLatestWebVersion() {
  return myAxios.get('/client-version/web-version/');
}

export async function getLatestAppVersion() {
  return myAxios.get('/client-version/app-version/');
}
